require('./index.css');
let request = require('@common/request');
let mask = require('../mask/index');

$(function () {//初始化 老虎机


});



// WEBPACK FOOTER //
// ./modules/whyuse/index.js